import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPause, faPlay, faStop } from '@fortawesome/free-solid-svg-icons';
import MicrophoneMonitor from './MicrophoneMonitor';
import RecordingMicPicker from './RecordingMicPicker';
import formatClockTime from './formatClockTime';
import { RECORDING_WARN_25_S } from './recordingLimits';

const RecordingControls = ({
  elapsedSeconds,
  isPaused,
  micLevel,
  pauseDisabled,
  micPickerDisabled,
  micPickerDisabledReason,
  selectedDeviceId,
  onSelectDevice,
  onPauseToggle,
  onStop
}) => (
  <div className="recording-controls">
    <div className={`recording-indicator ${isPaused ? 'paused' : ''}`}>
      <div className="recording-dot" />
      <span className="recording-label">{isPaused ? 'PAUSED' : 'REC'}</span>
    </div>
    <span className={`recording-timer${elapsedSeconds >= RECORDING_WARN_25_S ? ' near-limit' : ''}`}>
      {formatClockTime(elapsedSeconds)}
    </span>
    <MicrophoneMonitor
      mode="levelOnly"
      active
      externalLevel={isPaused ? 0 : micLevel}
      dimmed={isPaused}
    />
    <RecordingMicPicker
      selectedDeviceId={selectedDeviceId}
      disabled={micPickerDisabled}
      disabledReason={micPickerDisabledReason}
      onSelectDevice={onSelectDevice}
    />
    <div className="recording-buttons">
      <button
        className="recording-button pause-button"
        onClick={onPauseToggle}
        disabled={pauseDisabled}
        title={isPaused ? 'Resume' : 'Pause'}
      >
        <FontAwesomeIcon icon={isPaused ? faPlay : faPause} />
      </button>
      <button
        className="recording-button stop-button"
        onClick={onStop}
        title="Stop Recording"
      >
        <FontAwesomeIcon icon={faStop} />
      </button>
    </div>
  </div>
);

export default RecordingControls;
